import styled from 'styled-components';
import Image from '../../../../atoms/ResponsiveImage/index';
export const Video = styled('video')`
  width: 100%;
  margin: auto;
  max-height: 55vh;
  border-radius: 15px;

  @media screen and (max-width: 499px) {
    max-height: 60vh;
  }
`;
export const ImageWrapper = styled.div`
  height: 100%;
  border-radius: 15px;
  overflow: hidden;

  @media screen and (max-width: 499px) {
    border-radius: 12px;
  }
`;
export const PopupImage = styled(Image)`
  display: block;
  max-height: 55vh;
  object-fit: cover;
  width: auto;
  max-width: 100%;
  border-radius: 15px;

  @media screen and (max-width: 499px) {
    max-height: 60vh;
  }
`;
export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;